import { render, staticRenderFns } from "./AddNewDy4GCollect.vue?vue&type=template&id=1be8b58c&"
import script from "./AddNewDy4GCollect.vue?vue&type=script&lang=js&"
export * from "./AddNewDy4GCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports